import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "Satisfaction" })
export default class Satisfaction extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public formData: any = {
        question01: null,
        question02: null,
        question03: null,
        question04: null,
        question05: null,
        question06: null,
        question07: null,
        question08: null,
        question09: null,
        question10: null
    };
    public validationErrors: any[] = [];
    public satisfactionRates: any[] = [];

    @Prop() readonly recaptchaSiteKey: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        await this.getData();
    }

    public mounted() {
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute("src", "https://www.google.com/recaptcha/api.js");
        document.head.appendChild(recaptchaScript);
    }

    public async getData() {
        this.satisfactionRates = (await Axios.post(this.routes.Support_GetSatisfactionData, null)).data;
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];

        this.isLoading = true;

        try {
            await Axios.post(this.routes.Support_CouponPostSatisfaction, this.formData, { headers: { "RecaptchaVerificationToken": (<any>window).grecaptcha.getResponse() } });

            GTagHelper.sendEvent("form_submit", "satisfaction");

            this.isSuccess = true;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }

            (<any>window).grecaptcha.reset();
        }

        this.isLoading = false;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};